import { render } from "./bulkImport.vue?vue&type=template&id=213dead1"
import script from "./bulkImport.vue?vue&type=script&lang=js"
export * from "./bulkImport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__